export default "__VITE_ASSET__4hwOIHl5__"